<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>费用编号：</p>
        <el-input v-model="shipIpt" size="mini" style="width: 150px" placeholder="请输入费用编号"
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'shipIpt')}"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>公司类型：</p>
        <el-select v-model="voyageIpt" filterable clearable size="mini" style="width: 150px" placeholder="请选择公司类型">
          <el-option v-for="item in companyOptions" :key="item.val" :label="item.label" :value="item.val" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>公司名称：</p>
        <el-input v-model="numberIpt" size="mini" style="width: 150px" placeholder="请输入公司名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>费用类型：</p>
        <el-select v-model="batchIpt" filterable clearable size="mini" style="width: 150px" placeholder="请选择费用类型">
          <el-option v-for="item in companyListfee" :key="item.typeId" :label="item.typeName" :value="item.typeId" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 300px">
        <p>费用时间：</p>
        <el-date-picker
          v-model='timeIpt'
          type='daterange'
          range-separator='-'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          style='width: 220px;'
          start-placeholder='开始日期'
          end-placeholder='结束日期' size='mini'>
        </el-date-picker>
        <el-date-picker v-if="false" v-model="timeIpt[0]" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="date" placeholder="开始日期" />
        <span v-if="false" style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-if="false" v-model="timeIpt[1]" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <!--      <div class="navContainer" style="width: 270px">-->
      <!--        <p>是否生成对账单：</p>-->
      <!--        <el-select-->
      <!--          v-model="isReconciliation"-->
      <!--          filterable-->
      <!--          clearable-->
      <!--          size="mini"-->
      <!--          style="width: 150px"-->
      <!--          placeholder="请选择是否生成对账单">-->
      <!--          <el-option-->
      <!--            v-for="item in auditOptions"-->
      <!--            :key="item.val"-->
      <!--            :label="item.label"-->
      <!--            :value="item.val" />-->
      <!--        </el-select>-->
      <!--      </div>-->
      <div class="navContainer" style="width: 250px">
        <p style="width: 90px">生成对账单：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width: 150px">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 250px">
        <p style="width: 100px">是否生成台账：</p>
        <el-select v-model="isStandingBook" filterable size="mini" style="width: 150px">
          <el-option v-for="item in isStandingBookOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>结算人员：</p>
        <el-input v-model="settlementPersonnel" size="mini" style="width: 150px" placeholder="请输入结算人员" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="createBy" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>台账月：</p>
        <el-input v-model="standingBookMonthi" size="mini" style="width: 150px" placeholder="请输入台账月" />
      </div>
      <div class="navContainer" style="width: 250px">
        <p style="width: 90px">是否有附件：</p>
        <el-select v-model="auditTypei" filterable size="mini" style="width: 150px">
          <el-option v-for="item in auditTypeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 280px">
        <p style="width: 100px">台账生成编号：</p>
        <el-input v-model="code" size="mini" style="width: 180px" placeholder="请输入台账生成编号" />
      </div>
      <div class="navContainer" style="width: 400px">
        <p style="width: 110px">录入时间：</p>
        <el-date-picker
          v-model='createTime'
          type='daterange'
          range-separator='-'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          style='width: 220px;'
          start-placeholder='开始日期'
          end-placeholder='结束日期' size='mini'>
        </el-date-picker>
        <el-date-picker v-if="false" v-model="createTime1" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="date" placeholder="开始日期" />
        <span v-if="false" style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-if="false" v-model="createTime2" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="date" placeholder="结束日期" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">添加</el-button>
        <el-button size="small" type="primary" @click="createBtn">生成对账单</el-button>
        <el-button size="small" type="primary" @click="standingBookBtn">生成台账</el-button>
        <!--        <el-button size='mini' type='primary' @click='exportClick'>导出</el-button>-->
        <!--        <span @click='download' class='pointer'>模板下载</span>-->
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span class="el-icon-download el-icon--right" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center" @click="download">模板下载</span>
          <span @click="exportClick" style="cursor: pointer; font-size: 16px">导出数据</span>
          <span style="cursor: pointer">
            <el-upload ref="upload" class="upload-demo" :action="importUrl" :auto-upload="true" :show-file-list="false" :data="uploadData1" :on-success="planOnSuccess" :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          tooltip-effect="dark"
          @select="handleCurrentChange1"
          @select-all="handleCurrentChangeAll"
          :row-style="rowStyle"
          :reserve-selection="true"
          :row-key="
            row => {
              return row.id;
            }
          "
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <!--            :selectable="selectable"-->
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="costNum" label="费用编号" align="center" width="130" show-overflow-tooltip />
          <el-table-column prop="standingBookMonth" label="台账月" align="center" />
          <el-table-column prop="companyType" label="公司类型" align="center">
            <span slot-scope="scope">{{ scope.row.companyType | getCompanyType }}</span>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" width="130" show-overflow-tooltip />
          <el-table-column prop="offlineNumber" label="线下审批号" align="center" width="150" show-overflow-tooltip />
          <el-table-column prop="costTypeName" label="费用类型" align="center" />
          <el-table-column prop="costInstruction" label="费用说明" align="center" width="150" show-overflow-tooltip />
          <el-table-column prop="costTime" label="费用时间" align="center" show-overflow-tooltip />
          <el-table-column prop="taxRate" label="税率(%)" align="center" />
          <el-table-column prop="costAmount" label="费用金额" align="center" />
          <el-table-column prop="auditType" label="是否有附件" align="center">
            <span slot-scope="scope">{{ scope.row.auditType | getAuditType }}</span>
          </el-table-column>
          <el-table-column prop="isStatement" label="生成对账单" min-width="80" align="center">
            <span slot-scope="scope">{{ scope.row.isStatement === 1 ? '是' : '否' }}</span>
          </el-table-column>
          <el-table-column prop="settNo" label="对账单编号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="title" label="对账单标题" align="center" />
          <el-table-column prop="createBy" label="录入人" align="center" />
          <el-table-column prop="code" label="台账生成编号" align="center" width="130" />
          <el-table-column prop="settlementPersonnel" label="结算人员" align="center" />
          <el-table-column prop="contractCode" label="合同号" align="center" width="160" />
          <el-table-column prop="createdTime" label="录入时间" align="center" width="130"/>
          <el-table-column label="操作" width="530" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="detailClick(scope.row.id)" style="margin-bottom: 10px;">详情 </el-button>
              <el-button v-if="scope.row.isStatement == 0 && scope.row.code == null" size="mini" type="primary" @click="modify(scope.row)" class="yellow-bg">修改 </el-button>
              <!--              <el-button v-if='scope.row.auditType==1' size='mini' type='info'-->
              <!--                         @click='cancelClick(scope.row)'>取消审核-->
              <!--              </el-button>-->
              <el-button v-if="scope.row.auditType == 4" size="mini" type="primary" @click="againClick(scope.row)">重新提交 </el-button>
              <el-button v-if="scope.row.isStatement == 0" size="mini" type="danger" @click="disableClick(scope.row.id)">删除 </el-button>
              <el-button v-if="scope.row.auditType == 2 && scope.row.isStatement !== 1" size="mini" type="primary" @click="referClick(scope.row)">提交对账 </el-button>
              <el-button v-if="scope.row.isStatement === 1" size="mini" type="primary" @click="cancelReferClick(scope.row.id)">取消对账 </el-button>
              <el-button size="mini" type="primary" @click="confirmBtn(scope.row.id, scope.row.standingBookMonth)">
                {{ scope.row.standingBookMonth === null ? '添加台账月' : '修改台账月' }}
              </el-button>
              <el-button size="mini" type="primary" @click="addAttachmentClick(scope.row)">添加附件 </el-button>
              <el-button size="mini" type="primary" @click="onClickEditSettlementPersonnel(scope.row)">修改结算人员 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px" center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company" v-loading="formLoading">
        <el-form :model="modifyData" label-width="95px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" prop="infor">
            <el-form-item label="公司类型：" prop="companyTypeId" style="margin-top: 10px">
              <el-radio-group v-model="modifyData.companyTypeId" @change="companyTypeChange" value-key="companyTypeName">
                <el-radio v-for="(item, index) in companyTypeList" :label="item.companyTypeId" :key="`${index}tr`">{{ item.companyTypeName }} </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公司名称：" prop="companyId">
              <el-select v-model="modifyData.companyId" style="width: 100%" filterable placeholder="请选择公司名称" size="mini" value-key="id">
                <el-option v-for="(item, index) in companyList" :label="item.name" :value="item" :key="`${index}sds`"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用类型：" prop="costTypeName">
              <el-select v-model="modifyData.costTypeName" style="width: 100%" filterable placeholder="请选择费用类型" size="mini" value-key="typeId">
                <el-option v-for="(item, index) in companyListfee" :label="item.typeName" :value="item" :key="`${index}sds`"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用说明：" prop="content">
              <el-input type="textarea" placeholder="请输入内容" v-model="modifyData.content" size="mini" />
            </el-form-item>
            <el-form-item label="费用时间：" prop="startTime">
              <el-date-picker v-model="modifyData.startTime" type="datetime" size="mini" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="线下审批号：" prop="offlineNumber">
              <el-input type="text" placeholder="请输入内容" v-model="modifyData.offlineNumber" size="mini" />
            </el-form-item>
            <el-form-item label="费用金额：" prop="contentes">
              <el-input type="text" placeholder="请输入内容" v-model="modifyData.contentes" size="mini" />
            </el-form-item>
            <el-form-item label="税率(%)：" prop="rate">
              <el-input type="number" placeholder="请输入内容" v-model="modifyData.rate" size="mini" />
              <!-- <el-input-number v-model="modifyData.rate" controls-position="right" @change="handleChange" size="mini" placeholder="请输入内容" style="width: 100%"></el-input-number> -->
            </el-form-item>
            <el-form-item label="结算人员：" prop="settlementPersonnel">
              <el-input type="text" placeholder="请输入内容" v-model="modifyData.settlementPersonnel" size="mini" :disabled="dialogTitle == '添加其他费用' ? false : true" />
            </el-form-item>
          </div-border>
          <div-border label="合同设置" divStyle="margin-top: 10px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="合同设置：">
                  <el-row>
                    <el-col :span="12">
                      <span class="set-up" @click="contractBtn">设置</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="modifyData.companyName || modifyData.codeNumber">
                    <el-col :span="24">
                      <span class="item-span">合同名称：{{ modifyData.companyName }}</span>
                    </el-col>
                    <el-col :span="15">
                      <span class="item-span">合同编号：{{ modifyData.codeNumber }}</span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="上传附件" :is-need="true">
            <el-form-item style="margin-top: 15px">
              <div class="imgUp">
                <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :auto-upload="true" :before-upload="beforeAvatarUpload" :show-file-list="false" :data="uploadData" :on-change="uploadChange" :on-success="res => uploadImgFun(res, 2)" :file-list="modifyData.img" :limit="5">
                  <!--                    <i class="el-icon-plus"/>-->
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" style="margin-top: 6px; margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
                </el-upload>
                <div v-for="(item, index) in modifyData.img">
                  <div class="upload" style="display: flex; justify-content: space-between">
                    {{ item.name }}
                    <div>
                      <i class="el-icon-loading" v-if="item.status !== 'success'"></i>
                      <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item, index)" v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg' || item.name.substring(item.name.indexOf('.')) == '.jpg' || item.name.substring(item.name.indexOf('.')) == '.png' || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                      <i class="el-icon-upload2" @click="uploadClick(item, index)"></i>
                      <i class="el-icon-delete" @click="handleRemove(item, index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick()">确认 </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="900px" center>
      <div class="detail" v-loading="detailLoading">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData" label-position="left">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="费用编号:">
                    <span>{{ detailData.costNum }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司类型:">
                    <span>{{ detailData.companyType | getCompanyType }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称:">
                    <span>{{ detailData.companyName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="费用类型:">
                    <span>{{ detailData.costTypeName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="费用说明:">
                    <span>{{ detailData.costInstruction }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="费用时间:">
                    <span>{{ detailData.costTime }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税率:">
                    <span>{{ detailData.taxRate }}%</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="费用金额:">
                    <span>{{ detailData.costAmount }}元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结算人员:">
                    <span>{{ detailData.settlementPersonnel }}</span>
                  </el-form-item>
                </el-col>
                <!-- offlineNumber -->
                <el-col :span="12">
                  <el-form-item label="线下审批号:">
                    <span>{{ detailData.offlineNumber }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="operation" v-if="detailData.attachmentList && detailData.attachmentList.length > 0">
            <div class="operationTitle">
              <div class="line" />
              <span>附件信息</span>
            </div>
            <div class="baseInfoContent">
              <div style="display: flex">
                <el-form :model="detailData" label-position="left" style="width: 100%">
                  <el-row :gutter="30" style="width: 100%" v-for="(item, index) in detailData.img" :key="`${index}b`">
                    <el-col :span="14">
                      <el-form-item>
                        {{ item.name }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item>{{ item.uploadTime }}</el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item>
                        <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item, index)" v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg' || item.name.substring(item.name.indexOf('.')) == '.jpg' || item.name.substring(item.name.indexOf('.')) == '.png' || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                      </el-form-item>
                      <el-col :span="2">
                        <i class="el-icon-download pointer" @click="downloadClick(item.id)" />
                      </el-col>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>操作记录</span>
            </div>
            <div class="baseInfoTable mt10">
              <el-table :data="detailData.operateRecordList" border max-height="300">
                <el-table-column prop="createTime" label="操作时间" align="center" width="160px" />
                <el-table-column prop="operateType" label="操作类型" align="center" />
                <el-table-column prop="operationName" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="图片预览" :visible.sync="dialogImageVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :title="dialogBillTitle" :visible.sync="billDialogVisible" center @before-close="dialogBillClose" :close-on-click-modal="false">
      <div class="nav">
        <div class="navContainer">
          <p style="width: 120px; display: inline-block; text-align: right">对账单编号：</p>
          <el-input v-model="billData.settNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
        </div>
        <div class="navContainer">
          <p style="width: 60px; display: inline-block; text-align: right">标题：</p>
          <el-input v-model="billData.title" size="mini" style="width: 120px" placeholder="请输入标题" />
        </div>
        <div class="navBtn" style="display: flex; justify-content: flex-end">
          <el-button size="small" class="searchBtn" @click="billSearchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="billResetBtn">重置</el-button>
          <el-button size="small" class="submit" @click="submit">确认</el-button>
        </div>
      </div>
      <div class="tableContent">
        <el-table ref="billRef" :data="billTable.table" v-loading="billTableLoad" style="width: 100%" border :header-cell-style="headerCellStyle" highlight-current-row @current-change="handleCurrentChange">
          <el-table-column align="center" width="50px">
            <template v-slot="{ row, $index }">
              <el-radio v-model="radioId" :label="row.id" @change="val => handleChange(val, row.id)">&nbsp; </el-radio>
            </template>
          </el-table-column>
          <el-table-column property="settNo" align="center" label="对账单编号" width="139"></el-table-column>
          <el-table-column property="title" align="center" label="标题" width="130"></el-table-column>
          <el-table-column property="companyNameNew" align="center" label="公司" width="140"></el-table-column>
          <el-table-column label="合计含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.taxPrice }}</span>
                <span v-else-if="scope.row.settType === 2">{{ scope.row.taxSettPrice }}</span>
                <span v-else>{{ scope.row.taxPrice != null && scope.row.taxPrice > 0 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合计不含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.noTaxPrice }}</span>
                <span v-else>{{ scope.row.noTaxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 10px">
        <span>共{{ billDataTotal }}条</span>
        <el-pagination :page-sizes="[100, 200, 300, 400]" :page-size="100" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
      </div>
    </el-dialog>
    <el-dialog :title="dialogLedgerTitle" :visible.sync="ledgerVisible" width="400px" center @close="ledgerClose">
      <div class="leader-input">
        <span>请输入台账月：</span>
        <el-date-picker v-model="standingBookMonth" size="mini" value-format="yyyy-MM" type="month" placeholder="请选择台账月" />
        <div style="display: inline-block; width: calc(100% - 130px); text-align: right; margin-top: 10px">
          <el-button size="small" class="searchBtn" @click="dialogSubmit(id)">确 定</el-button>
          <el-button size="small" class="resetBtn" @click="dialogMouthClose">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="importShow ? '导入生成对账单' : '生成对账单'" :visible.sync="dialogElseVisible" width="950px" center @close="dialogElseClose">
      <else-Add-account :check-table-data="JSON.parse(JSON.stringify(checkTableData))" :import-show="importShow" @selectionTable="selectChange" :initType="'else'" ref="accountState">
        <template slot="label">基础信息</template>
      </else-Add-account>
    </el-dialog>
    <el-dialog title="添加附件" :visible.sync="dialogAddVisible" width="900px" center @close="dialogAddClose" :close-on-click-modal="false" top="20vh">
      <el-form :model="modifyData" label-width="95px" ref="ruleForm">
        <div-border label="上传附件" :is-need="true">
          <el-form-item style="margin-top: 15px" prop="img">
            <div class="imgUp">
              <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :auto-upload="true" :before-upload="beforeAvatarUpload" :show-file-list="false" :data="uploadData" :on-change="uploadChange" :on-success="res => uploadImgFun(res, 2)" :file-list="modifyData.img" :limit="5">
                <!--                    <i class="el-icon-plus"/>-->
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" style="margin-top: 6px; margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
              </el-upload>
              <div v-for="(item, index) in modifyData.img">
                <div class="upload" style="display: flex; justify-content: space-between">
                  {{ item.name }}
                  <div>
                    <i class="el-icon-loading" v-if="item.status !== 'success'"></i>
                    <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item, index)" v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg' || item.name.substring(item.name.indexOf('.')) == '.jpg' || item.name.substring(item.name.indexOf('.')) == '.png' || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                    <i class="el-icon-upload2" @click="uploadClick(item, index)"></i>
                    <i class="el-icon-delete" @click="handleRemove(item, index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div-border>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addAttachmentBtn()"> 确认 </el-button>
          <el-button size="medium" class="resetBtn" @click="dialogAddClose">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="修改结算人员" :visible.sync="dialogFormVisibleEditSP" width="600px" @close="handleCloseEditSP">
      <el-form :model="formEditSP" label-width="90px" style="margin-top: 20px" :rules="rulesEditSP" ref="formEditSP">
        <el-form-item label="结算人员" prop="settlementPersonnel">
          <el-input v-model="formEditSP.settlementPersonnel" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="btnContainer">
        <el-button @click="dialogFormVisibleEditSP = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="onClickSureEditSP" size="medium" :loading="loadingSureEditSP">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogContratTitle" :visible.sync="addVisible" :close-on-click-modal="false" append-to-body width="910px">
      <div class="navContract">
        <div class="navContainer">
          <p>合同编号：</p>
          <el-input v-model="addData.codeNumber" size="mini" style="width: 150px" placeholder="请输入合同编号" />
        </div>
        <div class="navContainer">
          <p>合同名称：</p>
          <el-input v-model="addData.contractName" size="mini" style="width: 150px" placeholder="请输入合同名称" />
        </div>
        <div class="navContainer">
          <p>签约单位：</p>
          <el-input v-model="addData.companyName" size="mini" style="width: 150px" placeholder="请输入签约单位" />
        </div>
        <div class="navBtn">
          <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetContractBtn = false">重置</el-button>
          <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
        </div>
      </div>
      <el-table
        :data="contractData"
        highlight-current-row
        border
        ref="contractTable"
        @current-change="contractChange"
        v-loading="contractLoad"
        :header-cell-style="{
          color: '#3B3B3B',
          'font-weight': '700',
          padding: '0px',
          'font-size': '13px',
          height: '35px',
          background: '#E8E8E8',
        }"
        :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
        <el-table-column type="index" width="50" />
        <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
        <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
        <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
        <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
        <el-table-column property="startDate" label="开始日期" min-width="100" :formatter="getDate" align="center" />
        <el-table-column property="endDate" label="结束日期" min-width="100" :formatter="getDate" align="center" />
      </el-table>
      <div style="margin-top: 20px">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="addContractSizeChange" @current-change="addContractCurrentChange" :current-page.sync="page" :page-size="rows" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { baseUrl } from '@/config/env';
  import { otherExpenses, toExamine, othernewInvoice, delOtherNew, feeId, cancelAudit, otherinvoicingModification, againOtherNew, detailList, getReconciliation, settlementId, addStandingBookMonth, addAttachment, cancelRefer, generateAccount, updatePersonnel, getContract } from '@/service/contract';
  import { contractPageList, highwayLineSelectList, highwayLineSelectWaterSupplier } from '@/service/financial';
  import { assignVehicle, supplierListSelectPort } from '@/service/vehiclelog';
  import { changeTitle, customerInfoSelectList, selectListBySourceId } from '@/service/getData';
  import divBorder from '@/components/divBorder';
  import {formatTime, getSessionStore} from '@/config/mUtils';
  import accountState from '@/views/settle/supplier/components/accountState.vue';
  import { updateStandingBook } from '@/service/basicfile';
  import GenerateStatement from '@/views/settle/client-port-warehouse-settlement/components/generateStatement.vue';
  import { clientPortWarehouseSettlementUpdateBatchStandingBookMonth } from '@/service/warehouse';
  import consignorAccount from '@/views/settle/entrust/components/consignorAccount.vue';
  import elseAddAccount from '@/views/settle/else/components/elseAddAccount.vue';
  import refuteResourcesCarAccount from '@/views/settle/supplier/components/refuteResourcesCarAccount.vue';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { generateAccountByDifference } from '@/service/account';

  export default {
    components: {
      refuteResourcesCarAccount,
      consignorAccount,
      GenerateStatement,
      accountState,
      divBorder,
      elseAddAccount,
    },
    data() {
      return {
        startTimeTemp: '',
        endTimeTemp: '',
        createTime: ['', ''],
        rulesEditSP: {
          settlementPersonnel: [{ required: true, message: '请输入结算人员', trigger: 'blur' }],
        },
        loadingSureEditSP: false,
        formEditSP: {
          id: '',
          settlementPersonnel: '',
        },
        dialogFormVisibleEditSP: false,
        id: '',
        uploadUrl: baseUrl + '/web/attachmentFtp/upload',
        uploadData: {
          fileType: '0',
        },
        uploadData1: { mFile: '' },
        importUrl: '', //导入地址
        dialogImageUrl: '',
        dialogImageVisible: false,
        uploadIndex: '', //替换索引
        uploadFlag: false, //替换
        detailDialogVisible: false,
        detailData: {},
        detailLoading: false,
        formLoading: false,
        typeid: '0',
        companyListfee: [],
        radioId: '',
        companyTypeList: [
          {
            companyTypeId: 0,
            companyTypeName: '委托商',
          },
          {
            companyTypeId: 1,
            companyTypeName: '公路供应商',
          },
          {
            companyTypeId: 2,
            companyTypeName: '水路供应商',
          },
          {
            companyTypeId: 3,
            companyTypeName: '港口及其他',
          },
        ],
        companyOptions: [
          {
            val: '',
            label: '全部',
          },
          {
            val: 0,
            label: '委托商',
          },
          {
            val: 1,
            label: '公路供应商',
          },
          {
            val: 2,
            label: '水路供应商',
          },
          {
            val: 3,
            label: '港口及其他',
          },
        ],
        auditOptions: [
          {
            val: '',
            label: '全部',
          },
          {
            val: 1,
            label: '是',
          },
          {
            val: 0,
            label: '否',
          },
        ],
        selectedData: [],
        dialogElseVisible: false,
        settlement: '', // 生成对账单时的结算方式
        checkList: [], // 导入生成账单 选择数据
        billTitle: '',
        checkLoad: false,
        informationData: {
          company: '', // 公司名称
          Settlement: 1, // 结算方式
          sumIncluded: '', // 合计含税费用
          sumNotIncluded: '', // 合计不含税费用
          title: '', //
          isInvoicing: 0, // 是否抵扣开票
          Invoicing: '', // 选择抵扣费用
          Deductible: '', // 抵扣费用
          remark: '',
        },
        sumNotIncluded: 0,
        oldCompany: '', // 原公司
        checkTableData: [],
        visible: false, // 导入生成账单 显示
        importShow: false,
        stepData: [],
        companyList: [],
        modifyData: {
          companyId: {
            id: '',
            name: '',
          },
          contractId: '', //合同id
          companyName: '', // 合同名称
          codeNumber: '', // 合同编号
          companyTypeId: '', //公司类型
          // companyId: '', //公司名称
          content: '', //费用说明
          costTypeName: '', //费用类型
          startTime: '', //有效期
          contentes: '', //费用金额
          offlineNumber: '', //线下审批号
          costTypeId: '', //费用类型ID
          companynameId: '', //公司ID
          img: [],
          settlementPersonnel: '',
        },
        contractIdList: [], //合同id ---删除
        companyData: {},
        dialogAddVisible: false,
        dialogTitle: '',
        dialogVisible: false,
        addLoad: false,
        shipIpt: '',
        voyageIpt: '',
        batchIpt: '',
        numberIpt: '',
        chassisIpt: '',
        // isReconciliation: '',
        typeIpt: '',
        isStandingBook: '',
        settlementPersonnel: '',
        createBy: '',
        standingBookMonthi: '',
        auditTypei: '',
        code: '',
        timeIpt: ['', ''],
        createTime1:'',
        createTime2: '',
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '是',
          },
          {
            value: 0,
            label: '否',
          },
        ],
        isStandingBookOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '是',
          },
          {
            value: 0,
            label: '否',
          },
        ],
        auditTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '否',
          },
          {
            value: 0,
            label: '有',
          },
        ],
        page: 1,
        rows: 10,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        rules: {
          companyTypeId: {
            required: true,
            message: '请选择公司类型',
            trigger: 'blur',
          },
          companyId: {
            required: true,
            message: '请选择公司名称',
            trigger: 'blur',
          },
          typeName: {
            required: true,
            message: '请选合同类型',
            trigger: 'blur',
          },
          content: {
            required: true,
            message: '请输入费用说明',
            trigger: 'blur',
          },
          startTime: {
            required: true,
            message: '请选择有效期',
            trigger: 'blur',
          },
          offlineNumber: {
            required: true,
            message: '请输入线下审批号',
            trigger: 'blur',
          },
          contentes: {
            required: true,
            message: '请输入费用金额',
            trigger: 'blur',
          },
          rate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          settlementPersonnel: {
            required: true,
            message: '请输入结算人员',
            trigger: 'blur',
          },
          costTypeName: {
            required: true,
            message: '请输入费用类型',
            trigger: 'blur',
          },
        },
        ids: '',
        companyTypeListMap: new Map(),

        //提交对账单
        dialogBillTitle: '选择对账单',
        billDialogVisible: false,
        billTableLoad: false,
        billDataTotal: 0,
        otherId: '',
        settlementId: '',
        title: '',
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '90px',
          background: '#E8E8E8',
        },
        billData: {
          settNo: '',
          title: '',
          companyNameNew: '',
          companyName: '',
          settlementId: '', //行数据id
          page: 1,
          size: 10,
        },
        billTable: {
          table: [],
          title: '',
        },
        currentRow: null,
        billDataSelection: [], //对账单选择
        // 台账月
        standingBookMonth: '',
        status: '',
        dialogLedgerTitle: '修改台账月',
        ledgerVisible: false,
        ledgerLoad: false,
        ledger: '',
        ledgerData: [],
        importLoading: false,
        ledgerMonth: null,
        tableData: [],
        value: '',
        standingBookMothData: {
          id: '',
          standingBookMoth: '',
        },
        contractLoad: false,
        contractData: [],
        selectContract: {
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        dialogContratTitle: '合同设置',
        addVisible: false,
        addData: {},
      };
    },
    // checkTableData(val) {
    //   console.log(val);
    //   this.sumNotIncluded = this.calculation(val, 'sumNotIncluded');
    //   this.informationData.company = this.checkTableData[0].Waybill;
    //   this.oldCompany = this.checkTableData[0].Waybill;
    // },
    filters: {
      getCompanyType(val) {
        switch (val) {
          case 0:
            return '委托商';
          case 1:
            return '公路供应商';
          case 2:
            return '水路供应商';
          case 3:
            return '港口及其它';
        }
      },
      getAuditType(val) {
        switch (val) {
          case 1:
            return '否';
          case 2:
            return '是';
        }
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd');
        }
        return '';
      },
    },
    created() {
      this.searchBtn();
      this.feeIds();
      let token = getSessionStore('token');
      // this.importUrl = baseUrl + `/platform/othercost/import?access_token=${token}`;
      this.importUrl = getImportUrl('/othercost/import');
    },
    mounted() {
      this.companyTypeList.forEach(item => {
        this.companyTypeListMap.set(item.companyTypeName, item.companyTypeId);
      });
    },
    methods: {
      handleSearch() {
        const searchTerms = this.shipIpt.split(',').map(term => term.trim());
        const searchTerm = searchTerms.toString();
        console.log(searchTerm); // 打印多条件查询数组
      },
      handleCloseEditSP() {
        this.$refs.formEditSP.resetFields();
      },
      async onClickSureEditSP() {
        this.loadingSureEditSP = true;
        // console.log(this.formEditSP);
        const res = await updatePersonnel(this.formEditSP);
        console.log(res);
        if (res.status != 0) {
          this.$message.error(res.message);
          this.loadingSureEditSP = false;
        } else {
          this.$message.success(res.message);
          this.loadingSureEditSP = false;
          this.searchBtn();
          this.dialogFormVisibleEditSP = false;
        }
      },
      onClickEditSettlementPersonnel(row) {
        // console.log('id: ', row.id);
        // console.log('settlementPersonnel: ', row.settlementPersonnel);
        this.formEditSP.id = row.id;
        this.formEditSP.settlementPersonnel = row.settlementPersonnel;
        this.dialogFormVisibleEditSP = true;
      },
      handleChange(id, idx) {
        this.id = idx;
      },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 1024 / 1024 < 10;
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');

        // return isJPG && isLt10M
        this.addLoad = true;
        return isLt10M;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.modifyData.img.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.modifyData.img = fileList;
          console.log(fileList);
        }
        if (Object.keys(file).includes('response')) {
          if (file.response.status == -1) {
            this.modifyData.img.splice(this.modifyData.img.indexOf(file), 1);
          }
        }
      },
      handleRemove(item, index) {
        this.contractIdList.push(item.id)
        this.modifyData.img.splice(index, 1);
      },
      handlePictureCardPreview(item, index) {
        console.log(item);
        let token = getSessionStore('token');
        this.dialogImageUrl = baseUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;

        this.dialogImageVisible = true;
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();
      },
      //附件上传成功回调
      uploadImgFun(res, val) {
        this.addLoad = false;
        if (res.status == 0) {
          this.$message.success(res.message);
          // if (this.uploadFlag){//如果为替换，得到索引值进行替换
          //   this.dialogImageUrlList.splice(this.uploadIndex,1,{'id':res.data.id})
          //   console.log( this.dialogImageUrlList)
          //   this.uploadFlag =false;
          // }else {
          //   this.dialogImageUrlList.push({'id':res.data.id})
          //   console.log( this.dialogImageUrlList)
          // }
        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;
        }
      },
      closeDialog() {
        this.dialogImageVisible = false;
      },
      // 新增/修改 -- 确认
      addClick() {
        // console.log(this.modifyData.startTime);
        // console.log(this.selectContract.startDate);
        // console.log(this.modifyData.endTime);
        // console.log(this.selectContract.endDate);
        if (Date.parse(this.modifyData.startTime) >= Date.parse(this.selectContract.startDate) && Date.parse(this.modifyData.startTime) <= Date.parse(this.selectContract.endDate)) {
          this.$refs.ruleForm.validate(async valid => {
            if (valid) {
              this.addLoad = true;
              if (this.modifyData.img && this.modifyData.img.length > 0) {
                this.modifyData.attachmentIdStr = this.modifyData.img.map(item => item.id || item.response.data.id).join(',');
              }
              if (this.typeid === '0') {
                const data = {
                  companyType: this.modifyData.companyTypeId, //公司类型
                  companyName: this.modifyData.companyId.name, //公司名称
                  companyId: this.modifyData.companyId.id, //	公司id
                  costTypeId: this.modifyData.costTypeName.typeId, //	费用类型id
                  costTypeName: this.modifyData.costTypeName.typeName, //费用类型名称
                  costInstruction: this.modifyData.content, //费用说明
                  costTime: this.modifyData.startTime, //费用时间
                  costAmount: this.modifyData.contentes, //费用金额
                  taxRate: this.modifyData.rate, //税率
                  settlementPersonnel: this.modifyData.settlementPersonnel,
                  attachmentIdStr: this.modifyData.attachmentIdStr || '', //附件id
                  offlineNumber: this.modifyData.offlineNumber,
                  contractCode: this.selectContract.codeNumber,
                };
                await this.othernewInvoices(data);
              } else {
                if (this.modifyData.companyId.id === undefined) {
                  if (this.modifyData.costTypeName.typeName === undefined) {
                    const data = {
                      companyType: this.modifyData.companyTypeId, //公司类型
                      companyName: this.modifyData.companyId, //公司名称
                      companyId: this.modifyData.companynameId, //	公司id
                      costTypeId: this.modifyData.costTypeId, //	费用类型id
                      costTypeName: this.modifyData.costTypeName, //费用类型名称
                      costInstruction: this.modifyData.content, //费用说明
                      costTime: this.modifyData.startTime, //费用时间
                      costAmount: this.modifyData.contentes, //费用金额
                      taxRate: this.modifyData.rate, //税率
                      settlementPersonnel: this.modifyData.settlementPersonnel,
                      attachmentIdStr: this.modifyData.attachmentIdStr || '', //附件id
                      id: this.ids,
                      offlineNumber: this.modifyData.offlineNumber,
                      contractCode: this.selectContract.codeNumber,
                      deleteListattachmentList: this.contractIdList
                    };
                    this.otherinvoicingModifications(data);
                  } else {
                    const data = {
                      companyType: this.modifyData.companyTypeId, //公司类型
                      companyName: this.modifyData.companyId, //公司名称
                      companyId: this.modifyData.companynameId, //	公司id
                      costTypeId: this.modifyData.costTypeName.typeId, //	费用类型id
                      costTypeName: this.modifyData.costTypeName.typeName, //费用类型名称
                      costInstruction: this.modifyData.content, //费用说明
                      costTime: this.modifyData.startTime, //费用时间
                      costAmount: this.modifyData.contentes, //费用金额
                      taxRate: this.modifyData.rate, //税率
                      settlementPersonnel: this.modifyData.settlementPersonnel,
                      attachmentIdStr: this.modifyData.attachmentIdStr || '', //附件id
                      id: this.ids,
                      offlineNumber: this.modifyData.offlineNumber,
                      contractCode: this.selectContract.codeNumber,
                      deleteListattachmentList: this.contractIdList
                    };
                    this.otherinvoicingModifications(data);
                  }
                } else {
                  if (this.modifyData.costTypeName.typeName === undefined) {
                    const data = {
                      companyType: this.modifyData.companyTypeId, //公司类型
                      companyName: this.modifyData.companyId.name, //公司名称
                      companyId: this.modifyData.companyId.id, //	公司id
                      costTypeId: this.modifyData.costTypeName, //	费用类型id
                      costTypeName: this.modifyData.costTypeName, //费用类型名称
                      costInstruction: this.modifyData.content, //费用说明
                      costTime: this.modifyData.startTime, //费用时间
                      costAmount: this.modifyData.contentes, //费用金额
                      taxRate: this.modifyData.rate, //税率
                      settlementPersonnel: this.modifyData.settlementPersonnel,
                      attachmentIdStr: this.modifyData.attachmentIdStr || '', //附件id
                      id: this.ids,
                      offlineNumber: this.modifyData.offlineNumber,
                      contractCode: this.selectContract.codeNumber,
                      deleteListattachmentList: this.contractIdList
                    };
                    this.otherinvoicingModifications(data);
                  } else {
                    const data = {
                      companyType: this.modifyData.companyTypeId, //公司类型
                      companyName: this.modifyData.companyId.name, //公司名称
                      companyId: this.modifyData.companyId.id, //	公司id
                      costTypeId: this.modifyData.costTypeName.typeId, //	费用类型id
                      costTypeName: this.modifyData.costTypeName.typeName, //费用类型名称
                      costInstruction: this.modifyData.content, //费用说明
                      costTime: this.modifyData.startTime, //费用时间
                      costAmount: this.modifyData.contentes, //费用金额
                      taxRate: this.modifyData.rate, //税率
                      settlementPersonnel: this.modifyData.settlementPersonnel,
                      attachmentIdStr: this.modifyData.attachmentIdStr || '', //附件id
                      id: this.ids,
                      offlineNumber: this.modifyData.offlineNumber,
                      contractCode: this.selectContract.codeNumber,
                      deleteListattachmentList: this.contractIdList
                    };
                    this.otherinvoicingModifications(data);
                  }
                }
                this.searchBtn();
              }
              this.searchBtn();
            } else {
              return false;
            }
          });
        } else {
          this.$message.warning("费用时间必须在合同有效期范围内！");
        }

      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
      },
      //添加附件
      addAttachmentClick(row) {
        this.modifyData.img = [];
        this.modifyData = {};
        this.dialogAddVisible = true;
        this.id = row.id;
      },
      async addAttachmentBtn() {
        if (this.modifyData.img && this.modifyData.img.length > 0) {
          this.modifyData.attachmentIdStr = this.modifyData.img.map(item => item.response.data.id).join(',');
        }
        const { status, message } = await addAttachment({
          attachmentIdStr: this.modifyData.attachmentIdStr, //附件id
          id: this.id,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.dialogAddVisible = false;
      },
      dialogAddClose() {
        this.dialogAddVisible = false;
        this.modifyData.img = [];
      },
      //费用类型
      async feeIds() {
        const data = { categoryCd: 'other_cost_type' };
        let res = await feeId(data);
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyListfee = res.data.map(item => {
          return {
            typeName: item.classaName,
            typeId: item.id,
          };
        });
      },
      //其他费用新增
      async othernewInvoices(data) {
        const res = othernewInvoice(data);
        this.addLoad = false;
        res.then(item => {
          if (item.status !== 0) return this.$message.error(item.message);
          this.$message.success(item.message);
          this.searchBtn();
          this.dialogClose();
        });
      },
      async companyTypeChange(value) {
        if (this.modifyData.companyId) {
          this.modifyData.companyId = '';
        }
        // let res =await contractGetContractType(value.companyTypeId)
        // this.companyList = res.data.map((item)=>{
        //   return{
        //     companyId:item.id,
        //     companyName:item.name
        //   }
        // })
        console.log(value);
        //签约单位类型  2 公路 3 水路 4 港口
        switch (value) {
          case 0:
            await this._customerInfoSelectList();
            break;
          case 1:
            await this._highwayLineSelectList();
            break;
          case 2:
            await this._highwayLineSelectWaterSupplier();
            break;
          case 3:
            await this._shipDeployPublicSelectPort();
            break;
        }
      },
      async _customerInfoSelectList() {
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) return this.$message.error(res3.message);
        this.companyList = res3.data.map(item => {
          return {
            name: item.customer_name,
            id: item.id,
          };
        });
      },
      async _highwayLineSelectList() {
        let res = await highwayLineSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.name,
            id: item.id,
          };
        });
      },
      async _highwayLineSelectWaterSupplier() {
        let res = await highwayLineSelectWaterSupplier();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data;
      },
      async _shipDeployPublicSelectPort() {
        let res = await supplierListSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.supplier_name,
            id: item.id,
          };
        });
      },
      //close
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        this.addLoad = false
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.expensepaging();
      },
      // 关闭弹窗并刷新页面
      closeDialogAndSearch() {
        this.dialogElseClose();
        this.searchBtn();
      },
      // 取消审核
      cancelClick(row) {
        this.$confirm('确认取消审核当前任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelAudit(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      // 删除
      disableClick(id) {
        this.$confirm('确定要禁用当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await delOtherNew(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        this.detailLoading = true;
        let res = await detailList(id);
        let res2 = await selectListBySourceId(id);
        this.detailLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        if (res2.status !== 0) return this.$message.warning(res.message);
        this.detailData = res.data;
        //拼接 附件数组
        let array = res2.data.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
            uploadTime: item.uploadTime,
          };
        });
        this.$set(this.detailData, 'img', array);
      },
      //详情附件下载
      downloadClick(id) {
        let token = getSessionStore('token');
        window.location.href = baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' + token;
      },
      // 重新提交
      againClick(row) {
        this.$confirm('确定要重新提交当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await againOtherNew(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this.expensepaging();
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._customerInfoPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            // this.TableDatas = res.data;
            await this.searchBtn();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      // 分页查询
      async expensepaging() {
        if(!this.timeIpt) {
          this.timeIpt = ['', '']
        }
        if(!this.createTime) {
          this.createTime = ['', '']
        }
        const params = {
          page: this.page,
          rows: this.size,
          costNum: this.shipIpt, //费用编号
          companyType: this.voyageIpt, //公司类型
          companyName: this.numberIpt, //公司名称
          costTypeId: this.batchIpt, //费用类型
          // isReconciliation: this.isReconciliation, // 审核状态
          startTime: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], //开始时间
          endTime: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], //结束时间
          createTime1: this.createTime[0] === undefined ? '' : this.createTime[0],
          createTime2: this.createTime[1] === undefined ? '' : this.createTime[1],
          isStatement: this.typeIpt, //是否生成对账单
          isStandingBook: this.isStandingBook,
          settlementPersonnel: this.settlementPersonnel,
          createBy: this.createBy,
          standingBookMonth: this.standingBookMonthi,
          auditType: this.auditTypei,
          code: this.code,
        };
        this.tableLoad = true;
        const data = await otherExpenses(params);
        this.tableLoad = false;
        if (data.status !== 0) return this.$message.warning(data.message);
        this.total = data.data.total;
        this.TableDatas = data.data.records;
      },
      compareDate(d1, d2) {
        return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
      },
      // 结束时间
      dateChange(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      dateChange1(val) {
        if (this.createTime2 && this.createTime1 && this.compareDate(this.createTime1, this.createTime2)) {
          if (val == this.createTime2) this.createTime2 = '';
          if (val == this.createTime1) this.createTime1 = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      //复制Excel中多个费用编号，用逗号隔开
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'shipIpt':
            this.shipIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      // 重置
      resetBtn() {
        this.shipIpt = '';
        this.voyageIpt = '';
        this.batchIpt = '';
        this.auditIp = '';
        this.numberIpt = '';
        this.chassisIpt = '';
        this.timeIpt = ['', ''];
        this.createTime1 = ''
        this.createTime2 = ''
        this.typeIpt = '';
        this.isStandingBook = '';
        this.settlementPersonnel = '';
        this.createBy = '';
        this.standingBookMonthi = '';
        this.auditTypei = '';
        this.code = '';
      },
      //审核按钮
      toexaminebutton() {
        const data = {
          costNum: this.shipIpt, //费用编号
          companyType: this.voyageIpt, //公司类型
          companyName: this.numberIpt, //公司名称
          costTypeId: this.batchIpt, //费用类型
          startTime: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], //开始时间
          endTime: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], //结束时间
          isStatement: this.typeIpt, //是否生成对账单
          isStandingBook: this.isStandingBook,
          settlementPersonnel: this.settlementPersonnel,
          createBy: this.createBy,
          standingBookMonth: this.standingBookMonthi,
          auditType: this.auditTypei,
          code: this.code,
        };
        this.toExamines(data);
      },
      //审核
      async toExamines(data) {
        const result = toExamine(data);
        result.then(res => {
          console.log(res);
        });
      },
      // 新增
      addBtn() {
        this.dialogTitle = '添加其他费用';
        this.feeIds();
        this.dialogVisible = true;
        this.modifyData = {};
        this.typeid = '0';
      },
      download() {
        window.location.href = '/file/其它结算费用模板.xlsx';
      },
      //导出
      exportClick() {
        // let token = getSessionStore('token');
        const id = this.checkTableData.map(item => item.id).join(',')
        // window.location.href = `${baseUrl}/platform/othercost/exportResourcesCarXls?access_token=${token}&id=${id}&costNum=${this.shipIpt}&companyType=${this.voyageIpt}&companyName=${this.numberIpt}&costTypeId=${this.batchIpt}&startTime=${this.timeIpt[0] === undefined ? '' : this.timeIpt[0]}&endTime=${this.timeIpt[1] === undefined ? '' : this.timeIpt[1]}&isStatement=${this.typeIpt}&isStandingBook=${this.isStandingBook}&settlementPersonnel=${this.settlementPersonnel}&createBy=${this.createBy}&standingBookMonth=${this.standingBookMonthi}&auditType=${this.auditTypei}&code=${this.code}&createTime1=${this.createTime1 === undefined ? '' : this.createTime1}&createTime2=${this.createTime2 === undefined ? '' : this.createTime2}`;
        window.exportExcelGet('/platform/othercost/exportResourcesCarXls', `id=${id}&costNum=${this.shipIpt}&companyType=${this.voyageIpt}&companyName=${this.numberIpt}&costTypeId=${this.batchIpt}&startTime=${this.timeIpt[0] === undefined ? '' : this.timeIpt[0]}&endTime=${this.timeIpt[1] === undefined ? '' : this.timeIpt[1]}&isStatement=${this.typeIpt}&isStandingBook=${this.isStandingBook}&settlementPersonnel=${this.settlementPersonnel}&createBy=${this.createBy}&standingBookMonth=${this.standingBookMonthi}&auditType=${this.auditTypei}&code=${this.code}&createTime1=${this.createTime1 === undefined ? '' : this.createTime1}&createTime2=${this.createTime2 === undefined ? '' : this.createTime2}`)
      },
      //生成对账单
      createBtn() {
        if (this.checkTableData.length <= 0) return this.$message.warning('请至少选择一条结算数据！');
        let companyFlag = false; // 公司名称
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        if (this.checkTableData.length > 0) {
          const { companyId, taxRate } = this.checkTableData[0];
          this.checkTableData.forEach(item => {
            if (item.companyId !== companyId) {
              companyFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isStatement) {
              reconciliationFlag = true;
            }
          });
        }
        if (companyFlag) return this.$message.warning('只能选择同一家公司数据！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
        // 生成对账单弹窗显示
        this.dialogElseVisible = true;
        this.$nextTick(() => {
          this.$refs.accountState.$nextTick(() => {
            this.$refs.accountState.init(this.checkTableData);
          });
          this.importShow = false;
        });
      },
      //生成台账
      async standingBookBtn() {
        const id = this.checkTableData.map(item => item.id);
        const idString = id.join(',');
        this.importLoading = true;
        const { status, message } = await generateAccount({
          id: idString,
          page: this.page,
          row: this.size,
          costNum: this.shipIpt, //费用编号
          companyType: this.voyageIpt, //公司类型
          companyName: this.numberIpt, //公司名称
          costTypeId: this.batchIpt, //费用类型
          // isReconciliation: this.isReconciliation, // 审核状态
          startTime: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], //开始时间
          endTime: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], //结束时间
          isStatement: this.typeIpt, //是否生成对账单
          isStandingBook: this.isStandingBook,
          settlementPersonnel: this.settlementPersonnel,
          createBy: this.createBy,
          standingBookMonth: this.standingBookMonthi,
          auditType: this.auditTypei,
          code: this.code,
        });
        this.importLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 多选事件触发
      handleCurrentChange1(val) {
        this.checkTableData = val;
        // let Waybill = '';
        // if (val.length > 0) {
        //   const array = val.filter((item, index) => {
        //     // 取第一行
        //     if (index === 0) Waybill = item.companyName;
        //     // 赛选不等于第一行的数据
        //     return Waybill !== item.companyName;
        //   });
        //   // 筛选  供应商相同数据
        //   this.checkTableData = val.filter(item => Waybill === item.companyName);
        //   // 与第一行不相等的数据
        //   array.forEach(value => {
        //     // 只有使用表格原数据，才会生效   从表格原数据中赛选
        //     this.$message.warning('只能选择相同的公司');
        //     this.$refs.multipleTable.toggleRowSelection(
        //       this.TableDatas.find(item => value.id === item.id),
        //       false,
        //     );
        //   });
        // }
      },
      handleCurrentChangeAll(val) {
        this.checkTableData = val;
      },
      // 子组件 表格勾选触发
      selectChange(val) {
        // 先清空选择
        this.$refs.multipleTable.clearSelection();
        // 将子组件表格数据赋值。
        this.checkTableData = val;
        this.$nextTick(() => {
          val.forEach(row => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选  重新勾选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
          });
        });
      },
      dialogElseClose() {
        this.dialogElseVisible = false; //关闭窗口
      },
      selectable(row, index) {
        // 是否生成对账单 0：否 1：是  否 则不让勾选
        return row.isStatement !== 1;
      },
      //修改
      async modify(row) {
        this.dialogTitle = '修改其他费用';
        this.dialogVisible = true;
        this.formLoading = true;
        let res = await selectListBySourceId(row.id);
        this.formLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        //将拼接id字段转类型
        this.modifyData.attachmentIdStr = '';
        //拼接 附件数组
        let array = res.data.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
          };
        });
        this.typeid = '1';
        this.modifyData = {
          companyTypeId: row.companyType, //公司类型
          companyId: {
            id: row.companyId,
            name: row.companyName,
          }, //公司名称
          content: row.costInstruction,
          costTypeName: {
            typeName: row.costTypeName,
            typeId: row.costTypeId,
          },
          startTime: row.costTime,
          contentes: row.costAmount,
          rate: row.taxRate,
          costTypeId: row.costTypeId, //费用类型ID
          companynameId: row.companyId, //公司ID
          offlineNumber: row.offlineNumber,
          settlementPersonnel: row.settlementPersonnel,
          codeNumber: row.contractCode
        };
        this.$set(this.modifyData, 'img', array);
        switch (row.companyType) {
          case 0:
            this._customerInfoSelectList();
            break;
          case 1:
            this._highwayLineSelectList();
            break;
          case 2:
            this._highwayLineSelectWaterSupplier();
            break;
          case 3:
            this._shipDeployPublicSelectPort();
            break;
        }
        this.ids = row.id;
      },
      //修改数据接口
      otherinvoicingModifications(data) {
        console.log(data,'22222222222');
        const res = otherinvoicingModification(data);
        this.addLoad = false;
        res.then(item => {
          console.log(item);
          if (item.status !== 0) return this.$message.error(item.message);
          this.$message.success(item.message);
          this.searchBtn();
          this.dialogClose();
        });
      },
      // 合同设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          ...this.addData,
          page: this.page,
          rows: this.rows,
          companyName: this.modifyData.companyId.name,
        };
        this.contractLoad = true;
        let res = await getContract(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractData = res.data.records;
        this.total = res.data.total || 0;
        if (this.modifyData.contractId && this.addData.length > 0) {
          this.addData.forEach(item => {
            if (item.id === this.modifyData.contractId) {
              this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      //合同设置-重置
      resetContractBtn() {
        for (let key in this.addData) {
          this.addData[key] = '';
        }
      },
      //添加合同
      contractBtn() {
        // console.log(this.modifyData);
        if (!this.modifyData['companyId'] || !this.modifyData.companyId['name'] || this.modifyData.companyId['name'] === '') {
          return this.$message.error('请选择公司！');
        }
        this.selectContract = '';
        this._contractPageList();
        this.addVisible = true;
      },
      // 合同设置 —— 确认
      contractConfirm() {
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        this.modifyData.contractId = this.selectContract.id;
        this.modifyData.codeNumber = this.selectContract.codeNumber;
        this.modifyData.companyName = this.selectContract.contractName;
        // if (this.selectContract.startDate) this.modifyData.startTime = this.selectContract.startDate;
        if (this.selectContract.endDate) this.modifyData.endTime = this.selectContract.endDate;
        this.addVisible = false;
      },
      addContractSizeChange(rows) {
        this.rows = rows;
      },
      addContractCurrentChange(page) {
        this.page = page;
      },
      // 合同编号 —— 选中数据
      contractChange(val) {
        this.selectContract = val;
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      //提交对账
      referClick(row) {
        this.billDialogVisible = true;
        this.billData.settlementId = row.id;
        this.billData.companyName = row.companyName;
        this.otherId = row.id;
        this.billSearch();
      },
      //取消对账
      cancelReferClick(id) {
        this.$confirm('确定要取消对账吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelRefer(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      //台账月
      confirmBtn(id, standingBookMonth) {
        //打开弹窗
        this.ledgerVisible = true;
        this.standingBookMonth = standingBookMonth.slice(0, standingBookMonth.length - 2) + '-' + standingBookMonth.slice(standingBookMonth.length - 2, standingBookMonth.length);
        this.settlement = id;
        // this.searchBtn();
      },

      //关闭弹窗
      ledgerClose() {
        this.ledgerVisible = false;
      },
      //取消
      dialogMouthClose() {
        this.ledgerVisible = false;
      },
      async dialogSubmit() {
        const { status, message } = await addStandingBookMonth({
          month: this.standingBookMonth,
          id: this.settlement,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.searchBtn();
        this.dialogMouthClose();
      },
      //对账查询
      async billSearch() {
        this.billTableLoad = true;
        let obj = {
          companyName: this.billData.companyName,
          settNo: this.billData.settNo,
          title: this.billData.title,
          page: 1,
          size: 10,
        };
        const res = await getReconciliation(obj);
        this.billTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.billTable.table = res.data.records;
        this.billDataTotal = res.data.total;
      },
      billSearchBtn() {
        this.billSearch();
      },
      //单选
      handleCurrentChange(val) {
        this.currentRow = val;
      },

      //重置
      billResetBtn() {
        this.billData.settNo = '';
        this.billData.title = '';
      },
      //确认
      async submit() {
        // const params = this.billDataSelection.map(item => {
        //   return {
        //     otherId: this.otherId,
        //     settlementId: item.id,
        //   }
        // })

        const settId = this.id;
        const otherId = this.billData.settlementId;
        this.$confirm(`确认选择该对账单？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          console.log(otherId);
          console.log(settId);
          const { status, message } = await settlementId(otherId, settId);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.dialogBillClose();
          await this.expensepaging();
        });
      },
      //关闭对话框
      dialogBillClose() {
        this.billResetBtn();
        this.billDialogVisible = false;
        if (this.$refs.billRef) this.$refs.billRef.clearSelection();
      },
      billSizeChange(sizes) {
        this.billData.size = sizes;
      },
      billCurrentChange(page) {
        this.billData.page = page;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-loading-mask {
            z-index: 1020;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 30px 30px 5px;

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-form-item {
          margin-bottom: 8px;
        }

        .el-form-item__error {
          padding-top: 0;
          top: 90%;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .tableContainerNav span i.el-icon-upload.el-icon--right {
      font-size: 16px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-input--mini .el-input__inner {
      padding: 0 25px;
    }
  }

  .paginationContainer {
    margin-right: auto;
    display: flex;
    align-items: center;
    margin-bottom: 0px;

    span {
      font-size: 13px;
    }
  }

  .el-pagination {
    padding: 5px 3px;
  }
  .set-up {
    color: #3187ff;
    position: absolute;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }

  ::v-deep {
    .el-table th.require > div::before {
      content: '*';
      color: red;
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .cell .el-form-item {
      padding: 0 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__body {
      padding: 20px !important;
      max-height: 60vh;
      overflow-y: auto;
    }

    .el-pagination {
      text-align: left !important;
    }

    .el-dialog__footer {
      text-align: right !important;
    }

    .el-form-item__content {
      line-height: 40px;
    }

    .cell .el-radio {
      margin-right: 0px;
      float: left;
      left: 10px;
    }

    .el-radio:last-child {
      margin-top: 3px;
    }
  }
</style>
